module.exports = __webpack_public_path__ + "static/media/question.54d20599.png";